import { sendToDatadog } from '@shoflo/polymer';

import { PENDING, requestTypeToKnock } from 'constants/Knock';
import { withCurrentParams } from '../utils';
import { BROADCAST_SET_DIRECTOR_REQUEST_ASYNC } from '../Types';
import setDirectorRequestMessage from './setDirectorRequestMessage';
import { DIRECTOR_REQUEST_SENT } from 'constants/DirectorControls';

function setDirectorRequest({ requestType }) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        knock,
        meeting: { attendeeResponse },
        user
      } = getState();

      const name = user
        ? `${user.firstName} ${user.lastName}`.trim()
        : knock.name;

      const attendeeId = attendeeResponse?.Attendee?.AttendeeId;
      const socketId = socket._socket.id;

      const action = {
        type: BROADCAST_SET_DIRECTOR_REQUEST_ASYNC,
        request: async apiClient => {
          const { broadcast, ...restResponse } =
            await apiClient.broadcastKnock.createKnockRequest(
              teamId,
              eventId,
              broadcastId,
              {
                name,
                type: requestTypeToKnock[requestType],
                status: PENDING,
                attendeeId
              }
            );

          const payload = {
            broadcastId: broadcast,
            attendeeId,
            socketId,
            requestType,
            ...restResponse
          };
          // Emit directorRequest socket event
          emitSocketEvent(socket, payload);
          return payload;
        }
      };

      dispatch(action);
      dispatch(
        setDirectorRequestMessage({
          key: requestType,
          value: DIRECTOR_REQUEST_SENT
        })
      );

      sendToDatadog(
        'director-requests',
        {},
        `Presenter with id ${user?._id} sent a request of type ${requestType} to the director.`,
        false
      );
    }
  );
}

export default setDirectorRequest;

function emitSocketEvent(socket, payload) {
  console.log('Sending Request to Director', payload);

  socket.emit('directorRequest', payload);
}
